// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"8a7d9a2c","241":"0c375628"}[chunkId] + ".chunk.css";
};